import React from 'react';
import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';
import { Loader } from '@sdir/sds';
import { useCurrentApplication } from '../../../services/hooks';
import { ApplicationStatus } from '../../../types';
import { routes } from '../../../constants/routes';
import { RestrictedContentInfo } from '../../Atoms';
import { useNavigateWithLang } from '../../../services/hooks/useNavigateWithLang';

export const editableStatuses: string[] = [
  ApplicationStatus.Start,
  ApplicationStatus.Draft,
  ApplicationStatus.RequestMoreInformation,
];

interface EditApplicationGuardProps {
  children: any;
}

const EditApplicationGuard: React.FC<EditApplicationGuardProps> = ({ children }) => {
  const intl = useIntl();
  const navigate = useNavigateWithLang();
  const { application } = useCurrentApplication();
  const canUpload = editableStatuses.includes(application?.result?.applicationStatus || '');

  const handleBackToApplication = () => {
    navigate(
      generatePath(routes.applicationBase, { applicationUid: application?.result?.uid || '' })
    );
  };

  if (application?.loading) return <Loader />;

  if (application?.result && !canUpload) {
    return (
      <RestrictedContentInfo
        title={intl.formatMessage({ id: 'application.upload.missing.documentation.title.access' })}
        description={intl.formatMessage({
          id: 'application.upload.missing.documentation.error.access',
        })}
        onBack={handleBackToApplication}
        linkText={intl.formatMessage({ id: 'application.upload.missing.documentation.go.back' })}
      />
    );
  }

  return <>{children}</>;
};

export default EditApplicationGuard;
